export const tr = {
    accept: 'Uygula',
    cancel: 'İptal',
    title: 'Kullanıcı adı veya UID girin'
};
